<template>
  <transition name="pa-simple-fade">
    <section class="hero is-fullheight pa-global-loading" v-if="isShow">
      <div class="hero-body">
        <div class="container">
          <p>異界越境中</p>
          <p class="mini">暫くお待ち下さい。</p>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  name  : 'PaGlobalLoading',
  props : {
    hasGlobalLoading : {
      default : false,
    },
  },

  data(){
    return {
      isShow : false,
    };
  },
  
  watch : {
    hasGlobalLoading : {
      handler(value){
        this.isShow = value;
      },
      immediate: true,
    },
  }
  // ,mounted(){
  //   this.isShow = true;
  // }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

@keyframes globalLoadingFade
{
  0%   {
    transform: scale(.98);
    opacity:0;
  }
  50% {
    transform: scale(1);
    opacity:1;
  }
  100%   {
    transform: scale(.98);
    opacity:0;
  }
}

.pa-global-loading{
  position: fixed;
  z-index: 20;
  top:0;
  left:0;
  background:linear-gradient(0deg, $body-background-semi-light-darker 10%, $body-background-darker);
  min-width: 100vw;

  .container{
    margin-top:-4rem;

    p{
      color: $loading-text-color;
      text-shadow: -1px -1px 1px $body-background-darker, 1px 1px #72284A;
      text-align: center;
      font-size:2rem;
      margin-top:-1rem;
      animation: globalLoadingFade 5s infinite ease-in-out;

      &.mini{
        width:280px;
        margin:-.1rem auto 0;
        border-top:2px solid #602841;
        padding-left:.4rem;
        padding-top:.3rem;
        font-size: .9rem;
      }
    }
  }
}
</style>